import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector, LOCALE_ID } from '@angular/core';

import localeDe from '@angular/common/locales/de';

import { CommonModule, CurrencyPipe, registerLocaleData } from '@angular/common';
import { createCustomElement } from '@angular/elements';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { ChoosepaymentComponent } from './components/choosepayment/choosepayment.component';
import { DopaymentComponent } from './components/dopayment/dopayment.component';
import { CouponComponent } from './components/coupon/coupon.component';
import { ReadyComponent } from './components/ready/ready.component';
import { OpenComponent } from './components/open/open.component';
import { ChoosepaymentPaymentoverviewComponent } from './components/choosepayment-paymentoverview/choosepayment-paymentoverview.component';
import { API_URL, IMAGE_URL } from '@frontend/basic';
import { environment } from '../environments/environment';
import { CountdownComponent } from './components/countdown/countdown.component';
import { PadNumberPipe } from './pipes/padnumber.pipe';
import { ChecksuccessComponent } from './components/checksuccess/checksuccess.component';
import { AppComponent } from './app/app.component';
import { ChoosepaymentCouponCashingComponent } from './components/choosepayment-coupon-cashing/choosepayment-coupon-cashing.component';
import { ChoosepaymentPaymentproviderComponent } from './components/choosepayment-paymentprovider/choosepayment-paymentprovider.component';
import { Amazonpay, AmazonpayStarter, ApplePay, ChannelService, Googlepay, PaymentproviderSwitcherComponent, SpinnerComponent } from '@frontend/frontendlib';

@NgModule({
  declarations: [
    AppComponent,
    ChoosepaymentComponent,
    DopaymentComponent,
    ReadyComponent,
    OpenComponent,
    ChoosepaymentPaymentoverviewComponent,
    CountdownComponent,
    PadNumberPipe,
    ChoosepaymentCouponCashingComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    ChecksuccessComponent,
    SpinnerComponent,
    PaymentproviderSwitcherComponent,
    ChoosepaymentPaymentproviderComponent,
    CouponComponent,
    AmazonpayStarter,
    Amazonpay,
    Googlepay,
    ApplePay
  ],
  bootstrap: [],
  providers: [
    { provide: LOCALE_ID, useValue: 'de' },
    { provide: API_URL, useValue: environment.apiUrl },
    { provide: IMAGE_URL, useValue: environment.imageUrl },
    CurrencyPipe,
    ChannelService,
  ],
})
export class AppModule {
  constructor(private injector: Injector) {
    registerLocaleData(localeDe);
  }

  ngDoBootstrap() {
    const paymentapp = createCustomElement(AppComponent, {
      injector: this.injector,
    });
    customElements.define('app-payment', paymentapp);
  }
}
